import { RootState } from '@/redux/store';
import { createSelector } from '@reduxjs/toolkit';
import { LoadingStatuses } from '@/constants/constants';

export const selectTitleNavigationDrawerSlice = (state: RootState) => state.titleNavigationDrawer || {};
export const selectTitleNavigationDrawerIsSearching = createSelector(
  selectTitleNavigationDrawerSlice,
  (slice) => slice.status === LoadingStatuses.pending
);
export const selectTitleNavigationDrawerIsSearchFulfilled = createSelector(
  selectTitleNavigationDrawerSlice,
  (slice) => slice.status === LoadingStatuses.fulfilled
);
export const selectStatusById = createSelector(
  selectTitleNavigationDrawerSlice,
  (_: RootState, titleId: number | undefined) => titleId,
  (slice, titleId): LoadingStatuses | undefined => {
    if (titleId !== undefined) {
      return slice.statusById[titleId];
    }
  }
);
export const selectTitleFromTitlesMap = createSelector(selectTitleNavigationDrawerSlice, (slice) => {
  if (!slice.selectedTitle) return null;
  return slice.selectedTitlesMap[slice.selectedTitle.id];
});
export const selectSeasonEpisodes = createSelector(selectTitleNavigationDrawerSlice, (slice) => {
  if (!slice.selectedSeasonFilter) return [];
  return slice.selectedTitlesMap?.[slice.selectedSeasonFilter.id]?.children || [];
});
